module.exports = __webpack_public_path__ + "soundfont/NewDrumSamples/MP3/Snare Ghost-341395cb5e356d183ec51fe6f892b446.mp3";


//////////////////
// WEBPACK FOOTER
// ./soundfont/NewDrumSamples/MP3/Snare Ghost.mp3
// module id = 46
// module chunks = 0